const LEGACY_TO_CANONICAL_TRANSITIONS = {
  'transition/enquire': 'transition/inquire',
  'transition/send-offer-auto-eligible': 'transition/send-offer',
  'transition/accept-auto-eligible-offer': 'transition/accept-offer',
  'transition/decline-auto-eligible-offer': 'transition/decline-offer',
  'transition/counter-auto-eligible-offer': 'transition/counter-offer',
  'transition/request-payment-after-enquiry': 'transition/request-payment-after-inquiry',
  'transition/request-payment-after-inquiry-with-paypal':
    'transition/request-payment-after-inquiry',
  'transition/request-payment-after-enquiry-with-paypal':
    'transition/request-payment-after-inquiry',
  'transition/request-payment-after-offer-with-paypal': 'transition/request-payment-after-offer',
  'transition/custom-request-payment-after-enquiry': 'transition/request-payment-after-inquiry',
  'transition/request-payment-with-paypal': 'transition/request-payment',
  'transition/confirm-payment-with-paypal': 'transition/confirm-payment',
  'transition/custom-confirm-payment': 'transition/confirm-payment',
  'transition/expire-payment-with-paypal': 'transition/expire-payment',
  'transition/custom-expire-payment': 'transition/expire-payment',
  'transition/mark-delivered-with-paypal': 'transition/mark-delivered',
  'transition/custom-mark-delivered': 'transition/mark-delivered',
  'transition/mark-delivered-without-payout': 'transition/mark-delivered',
  'transition/operator-mark-delivered-with-paypal': 'transition/operator-mark-delivered',
  'transition/mark-received-from-purchased-with-paypal': 'transition/mark-received-from-purchased',
  'transition/custom-mark-received-from-purchased': 'transition/mark-received-from-purchased',
  'transition/mark-received-from-purchased-without-payout':
    'transition/mark-received-from-purchased',
  'transition/auto-cancel-with-paypal': 'transition/auto-cancel',
  'transition/auto-cancel-without-payout': 'transition/auto-cancel',
  'transition/cancel-with-paypal': 'transition/cancel',
  'transition/cancel-without-payout': 'transition/cancel',
  'transition/custom-cancel': 'transition/cancel',
  'transition/seller-cancel-with-paypal': 'transition/seller-cancel',
  'transition/seller-cancel-without-payout': 'transition/seller-cancel',
  'transition/auto-cancel-unshipped-with-paypal': 'transition/auto-cancel-unshipped',
  'transition/auto-cancel-unshipped-without-payout': 'transition/auto-cancel-unshipped',
  'transition/refund-initiated': 'transition/cancel',
  'transition/mark-received-with-paypal': 'transition/mark-received',
  'transition/custom-mark-received': 'transition/mark-received',
  'transition/mark-received-without-payout': 'transition/mark-received',
  'transition/auto-mark-received-with-paypal': 'transition/auto-mark-received',
  'transition/custom-auto-mark-received': 'transition/auto-mark-received',
  'transition/auto-mark-received-without-payout': 'transition/auto-mark-received',
  'transition/update-wallet-balance': 'transition/wallet-updated',
  'transition/dispute-with-paypal': 'transition/dispute',
  'transition/custom-dispute': 'transition/dispute',
  'transition/dispute-without-payout': 'transition/dispute',
  'transition/operator-mark-delivered-without-payout': 'transition/operator-mark-delivered',
  'transition/operator-dispute-with-paypal': 'transition/operator-dispute',
  'transition/operator-dispute-without-payout': 'transition/operator-dispute',
  'transition/auto-cancel-from-disputed-with-paypal': 'transition/auto-cancel-from-disputed',
  'transition/auto-cancel-from-disputed-without-payout': 'transition/auto-cancel-from-disputed',
  'transition/custom-auto-cancel-from-disputed': 'transition/auto-cancel-from-disputed',
  'transition/cancel-from-disputed-with-paypal': 'transition/cancel-from-disputed',
  'transition/cancel-from-disputed-without-payout': 'transition/cancel-from-disputed',
  'transition/custom-cancel-from-disputed': 'transition/cancel-from-disputed',
  'transition/mark-received-from-disputed-with-paypal': 'transition/mark-received-from-disputed',
  'transition/custom-mark-received-from-disputed': 'transition/mark-received-from-disputed',
  'transition/mark-received-from-disputed-without-payout': 'transition/mark-received-from-disputed',
  'transition/custom-review-1-by-customer': 'transition/review-1-by-customer',
};

const CANONICAL_TO_ALIASES_TRANSITIONS = Object.entries(LEGACY_TO_CANONICAL_TRANSITIONS).reduce(
  (acc, [legacyTransition, canonicalTransition]) => {
    const existingAliases = acc[canonicalTransition] || [];
    return {
      ...acc,
      [canonicalTransition]: [...existingAliases, legacyTransition],
    };
  },
  {}
);

const extractTransitionName = transitionOrTransitionName => {
  if (typeof transitionOrTransitionName === 'string') {
    return transitionOrTransitionName;
  }
  if (transitionOrTransitionName?.attributes?.name) {
    return transitionOrTransitionName.attributes.name;
  }
  return null;
};

export const toCanonicalTransitionName = transitionName => {
  if (!transitionName) {
    return transitionName;
  }
  return LEGACY_TO_CANONICAL_TRANSITIONS[transitionName] || transitionName;
};

export const getTransitionCandidateNames = transitionName => {
  if (!transitionName) {
    return [];
  }
  const canonicalTransition = toCanonicalTransitionName(transitionName);
  const aliases = CANONICAL_TO_ALIASES_TRANSITIONS[canonicalTransition] || [];
  return [canonicalTransition, ...aliases];
};

export const transitionNamesMatch = (transitionNameA, transitionNameB) => {
  if (!transitionNameA || !transitionNameB) {
    return false;
  }
  return toCanonicalTransitionName(transitionNameA) === toCanonicalTransitionName(transitionNameB);
};

export const resolveTransitionNameFromNextTransitions = (transitionName, nextTransitions = []) => {
  if (!transitionName) {
    return transitionName;
  }

  const nextTransitionNames = Array.isArray(nextTransitions)
    ? nextTransitions.map(extractTransitionName).filter(Boolean)
    : [];

  if (!nextTransitionNames.length) {
    return transitionName;
  }

  const candidates = getTransitionCandidateNames(transitionName);
  return nextTransitionNames.find(nextTransitionName => candidates.includes(nextTransitionName));
};

export const isTransitionInNextTransitions = (transitionName, nextTransitions = []) => {
  if (!Array.isArray(nextTransitions) || !nextTransitions.length) {
    return false;
  }
  return !!resolveTransitionNameFromNextTransitions(transitionName, nextTransitions);
};
